// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import formCreate from '@form-create/element-ui'
import httpRequest from '@/utils/httpRequest'
import httpjavaRequest from '@/utils/httpjavaRequest'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/public.css'
import store from './store'
import 'babel-polyfill'
import '@/permission' // permission control
import './assets/alicon/iconfont.css'
import cal from './api/numMath'
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts
Vue.prototype.cal = cal
// 挂载全局
Vue.prototype.$http = httpRequest // ajax请求方法
Vue.prototype.$https = httpjavaRequest // ajax请求方法

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(formCreate);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
  // components: { App },
  // template: '<App/>',  
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js